import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://fieldzai.com";
const DEFAULT_IMAGE = `${SITE_URL}/marketing/og/og-default.jpg`;

export const ORGANIZATION_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Fieldz AI",
  url: SITE_URL,
  logo: `${SITE_URL}/logo-dark.png`,
  email: "support@fieldzai.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "4190 E Commerce Way",
    addressLocality: "Sacramento",
    addressRegion: "CA",
    postalCode: "95834",
    addressCountry: "US",
  },
  sameAs: [
    "https://apps.apple.com/us/app/fieldz-ai/id6759849207",
    "https://play.google.com/store/apps/details?id=com.fieldzai.app",
  ],
};

export const SOFTWARE_JSONLD = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "Fieldz AI",
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web, iOS, Android",
  url: SITE_URL,
  description:
    "All-in-one field service management software: scheduling, dispatch, CRM, business phone and SMS, estimates, invoices, payments, and financial reporting.",
  offers: { "@type": "Offer", price: "69.00", priceCurrency: "USD" },
};

export const breadcrumbJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

export const faqJsonLd = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q || f.question,
    acceptedAnswer: { "@type": "Answer", text: f.a || f.answer },
  })),
});

const Seo = ({ title, description, path = "/", image = DEFAULT_IMAGE, jsonLd = null, noIndex = false }) => {
  const url = `${SITE_URL}${path}`;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Fieldz AI" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(b)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
